import React, { useEffect, useState } from 'react';
import { useGetApiRequests } from '../../common/CommonExport';
import { useLocation } from 'react-router-dom';
import ConfidentialityLetter from './confidentialityLetter/ConfidentialityLetter';
import PerformanceImprovement from './deprovision-letters/PerformanceImprovement';
import CPILetter from './confidentialityLetter/CpiLetter';
import OpafDocument from './opafDocument/OpafDocument';

import IspaDocument from './ispaDocument/IspaDocument';

import { AxiosError, AxiosResponse } from 'axios';
import { DocumentDetailApiResponse, GetLetterDetailsType } from './PreviewDocumentDetailTypes';

const PreviewDocumentDetail = () => {
  const getDocumentDetails = useGetApiRequests('getDocumentDetails', 'GET');
  const [getLetterDetails, setgetLetterDetails] = useState<GetLetterDetailsType>(null);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const employeeId = searchParams.get('employeeId');
  const documentCode = searchParams.get('documentCode');


  useEffect(() => {
    if (documentCode === "PBL" || documentCode === "PROJTBL") {
      getProjectBonusData()

    }
    else {
      getDocumentDetail()
    }
  }, [])
  const getDocumentDetail = () => {
    const params = {
      "employeeId": employeeId,
      "documentCode": documentCode
    }
    getDocumentDetails('', {}, params).then((res) => {
      const response = res as AxiosResponse<DocumentDetailApiResponse>;

      if (response?.data) {
        setgetLetterDetails(response?.data?.data)
      }
    })
      .catch((err: AxiosError) => {
        console.error(err);
      });
  }
  const getProjectBonusData = () => {
    const params = {
      "employeeId": employeeId,
      "documentCode": documentCode
    }
    getDocumentDetails(params, {}, params).then((res) => {
      const response = res as AxiosResponse<DocumentDetailApiResponse>;
      if (response?.data) {
        setgetLetterDetails(response?.data?.data)
      }
    })
      .catch((err: AxiosError) => {
        console.error(err);
      });
  }
  return (
    <div data-testid="template-container" className='template_container' >
      {documentCode === "INTNAGR" &&
        <ConfidentialityLetter getLetterDetails={getLetterDetails} />
      }
      {documentCode === "CONFAGR" &&
        <ConfidentialityLetter getLetterDetails={getLetterDetails} />
      }
      {documentCode === "APPTLTR" &&
        <ConfidentialityLetter getLetterDetails={getLetterDetails} />
      }
      {documentCode === "PIPGM" &&
        <PerformanceImprovement getLetterDetails={getLetterDetails} />
      }

      {documentCode === "CPI" && (
        <CPILetter getLetterDetails={getLetterDetails} />
      )}
      {
        documentCode === "OPAF" &&
        <OpafDocument getLetterDetails={getLetterDetails} />
      }

      {documentCode === "PCL" &&
        <PerformanceImprovement getLetterDetails={getLetterDetails} />
      }
      {documentCode === "PBL" &&
        <PerformanceImprovement getLetterDetails={getLetterDetails} />
      }
      {documentCode === "ISPA" &&
        <IspaDocument getLetterDetails={getLetterDetails} />
      }
    </div>
  )
}

export default PreviewDocumentDetail
